<template>
	<div class="page bg-fff pb-fixed-btn">
		<backTitleBar></backTitleBar>
		<img :src="userInfo.avatarImgPath || headImg" alt="" class="head-img round">
		<div class="my-name">{{userInfo.nickName}}</div>


		<div class="card" style="margin-top: 1.5rem;" v-if="userInfo.userRoleList.length > 1">
			<div class="setting-item click bd-bot"  @click="$router.push({name:'roleList'})">
				<div class="item-name">切换角色</div>
				<div class="item-value">{{roleName}}</div>
				<div class="item-right-icon alifont icon-fanhui1"></div>
			</div>
		</div>

		<div class="fixed-bot">
			<div class="btn click" @click="logoutFun">退出登录</div>
		</div>
	</div>

</template>
<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {mapActions} from 'vuex'
    import headImg from '@/assets/images/shopHome/tag6.png'
	export default{
		name:'index',
        components:{backTitleBar},
		data(){
			return {
                userInfo: this.$store.state.user,
                headImg,
			}
		},
		created(){
			this.$store.state.showFooter = false;
		},
		computed:{
			roleName(){
				if(this.userInfo.isQuarterManageRole){
					return '小区管理员'
				}else if(this.userInfo.isSupplierRole){
					return '补货人员'
				}
			}
		},
		mounted(){

		},
		methods:{
            ...mapActions([
                'handleLogout',
            ]),
            logoutFun(){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: "是否退出当前账户",
                    showCancelButton: true
                })
                    .then(() => {     //点击确认按钮后的调用
                        _this.handleLogout().then(() => {
                            // 地址栏重新刷新
                            location.reload()
                        })
                    })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
			}
		}
	}
</script>
<style lang="scss" scoped>
	.head-img{
		width: 1.44rem;
		height: 1.44rem;
		display: block;
		margin: 1rem auto 0;
	}
	.my-name{
		text-align: center;
		margin-top: .3rem;
		color: #333;
		font-size: .34rem;
		line-height: .48rem;
		font-weight: 600;
	}
	.role-name{
		margin-top: .1rem;
		text-align: center;
		line-height: .4rem;
		font-size: .26rem;
		color: #999;
	}
	.card {
		margin: 0 .25rem;
		background: #fff;
		border-radius: .24rem;
	}
	.setting-item {
		display: flex;
		padding: .28rem .32rem;
		align-items: center;
		.item-name {
			width: 1.8rem;
			font-size: .34rem;
			line-height: .48rem;
			color: #252D46;
		}
		.item-range {
			width: 3.3rem;
		}
		.item-rang-num {
			flex: 1;
			text-align: right;
			font-size: .32rem;
			line-height: .45rem;
			color: #919BA6;
		}
		.item-right {
			flex: 1;
			text-align: right;
			font-size: .32rem;
			line-height: .45rem;
			color: #919BA6;
		}
		.item-value {
			font-size: .32rem;
			line-height: .45rem;
			color: #919BA6;
			text-align: right;
			flex: 1;
		}
		.item-right-icon {
			font-size: .26rem;
			color: #919BA6;
			margin-left: .2rem;
		}
	}
</style>



// WEBPACK FOOTER //
// index.vue?15bbc802